import SuperdocViewer from '@/shared/components/SuperdocViewer/SuperdocViewer.vue';
import Vue from 'vue';
import { ModalProgrammatic as Modal } from 'buefy';
import { downloadFile } from '@/utils/helpers/functions.js';

function openSuperdocViewerModal({
  linktitle,
  id,
  modules = {},
  fields = null,
  annotations = null,
  source = null,
  editorStateJson = null,
  headerCtas = null,
  pdfViewer = {},
  onLoad = null,
  onError = null,
  events = {},
  parent = null,
  onCancel = null,
}) {
  const ctas = headerCtas || [];
  const modal = Modal.open({
    component: SuperdocViewer,
    parent: parent || this,
    canCancel: ['outside'],
    fullScreen: false,
    customClass: 'hrbr-superdoc-viewer-modal',
    width: 1100,
    props: {
      name: linktitle,
      id,
      source,
      editorStateJson,
      modules,
      headerCtas: ctas,
      fields,
      annotations,
      pdfViewer,
    },
    events: {
      error: (error) => {
        console.error('Error opening superdoc viewer', error);
        if (onError) onError(modal);
      },
      load: (file) => {
        if (onLoad) onLoad(modal, file);
      },
      close: () => {
        if (typeof onCancel === 'function') {
          onCancel();
        }
      },
      downloadCKdocument: async ({ name, data, setLoadingState }) => {
        // Set loading state to true
        if (setLoadingState) {
          setLoadingState(true);
        }

        try {
          const docxFileBlob = await Vue.prototype.$exportCkToPDF(name, id, data);
          downloadFile(docxFileBlob, `${name}.pdf`);
        } catch (error) {
          console.error('Download failed:', error);
        } finally {
          // Set loading state to false after download is complete
          if (setLoadingState) {
            setLoadingState(false);
          }
        }
      },
      ...events,
    },
    onCancel: () => {
      if (typeof onCancel === 'function') {
        onCancel();
      }
    },
  });
  return modal;
}

export default {
  install(Vue) {
    Vue.prototype.$openSuperdocViewerModal = openSuperdocViewerModal;
  },
};
